import { Box, Flex } from 'components/elements'
import { TableItemRow, TableTd } from 'theme/globalStyleCss'
import { ShimmerCss, TitleCss, IconButtonCss } from './styles'

export const DomainsShimmer = () => {
  return (
    <TableItemRow>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...TitleCss, width: '50%' }}></Box>
      </TableTd>
      <TableTd>
        <Flex justify={'end'}>
          <Box css={{ ...ShimmerCss, ...IconButtonCss, mr: '$space$5' }}></Box>
          <Box css={{ ...ShimmerCss, ...IconButtonCss }}></Box>
        </Flex>
      </TableTd>
    </TableItemRow>
  )
}
